/*
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License (AFL 3.0)
 *
 *  @author    Afternet <info@afternet.gr>
 *  @copyright 2022 Afternet
 *  @license   http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
 *
 */

import {BrowserRouter, Routes, Route, Navigate, useParams} from "react-router-dom";
import Layout from "./layouts/Layout";
import Home from "./views/Home";
import Login from "./views/account/Login";
import HowItWorks from "./views/pages/HowItWorks";
import Faq from "./views/pages/Faq";
import Pricing from "./views/account/Pricing";
import PrivacyPolicy from "./views/pages/PrivacyPolicy";
import CookiePolicy from "./views/pages/CookiePolicy";
import AboutUs from "./views/pages/AboutUs";
import Support from "./views/pages/Support";
import Contact from "./views/pages/Contact";
import Models from "./views/parts/Models";
import Makes from "./views/parts/Makes";
import PartsByCategory from "./views/parts/PartsByCategory";
import PartsListing from "./views/parts/PartsListing";
import PartPage from "./views/parts/PartPage";
import CarPage from "./views/cars/CarPage";
import CarsListing from "./views/cars/CarsListing";
import PartRequest from "./views/PartRequest";
import Register from "./views/account/Register";
import Dismantlers from "./views/dismantlers/Dismantlers";
import DismantlerLayout from "./layouts/DismantlerLayout";
import DismantlerCars from "./views/dismantlers/Dismantler-cars";
import DismantlerParts from "./views/dismantlers/Dismantler-parts";
import DismantlerPartsCategory from "./views/dismantlers/Dismantler-parts-category";
import DismantlerCompany from "./views/dismantlers/Dismantler-company";
import DismantlerGallery from "./views/dismantlers/Dismantler-Gallery";
import Checkout from "./views/account/Checkout";
import ForgotPass from "./views/account/forgotPass";
import PartsCategoriesAll from "./views/parts/PartsCategoriesAll";
import PartsListingAll from "./views/parts/PartsListingAll";
import CarsSearch from "./views/cars/CarSearch";
import { HelmetProvider } from 'react-helmet-async';
import AuthProvider from "./Hooks/useAuth";
import urls from "./Utils/urls";
import ProtectedRoute from "./components/ProtectedRoute";
import PrivateRoute from "./components/PrivateRoute";
import Terms from "./views/pages/Terms";
import {useTranslation} from "react-i18next";
import MailActivation from "./views/account/MailActivation";
import DashBoard from "./views/account/DashBoard";
import AdsPolicy from "./views/pages/AdsPolicy";
import Imprint from "./views/pages/Imprint";

function App() {
    const { t, i18n } = useTranslation();

    const helmetContext = {};

    return (
        <HelmetProvider context={helmetContext}>
        <BrowserRouter>
            <AuthProvider>
                <Routes>
                    <Route element={<Layout />}>

                        <Route path="*" element={<Home />} />

                        <Route path="/" element={<Navigate to={`/${i18n.options.lng}`} /> } exact />
                        <Route index path=":lang/" element={<Home />} />


                        <Route element={<ProtectedRoute />}>
                            <Route path=":lang/dashboard" element={<DashBoard />} />
                        </Route>
                        <Route path=":lang/login" element={<Login />} />
                        <Route path=":lang/register" element={<Register />} />
                        <Route path=":lang/forgot-password" element={<ForgotPass />} />
                        <Route path=":lang/pricing" element={<Pricing />} />
                        <Route path=":lang/checkout" element={<Checkout />} />
                        <Route path=":lang/activation" element={<MailActivation />} />

                        <Route path=":lang/models" element={<Models />} />
                        <Route path=":lang/models/:make" element={<Makes />} />

                        <Route path=":lang/parts/:make/:model/:year" element={<PartsByCategory />} />
                        <Route path=":lang/parts/listing/:make/:model/:part/:year/" element={<PartsListing />} />

                        <Route path=":lang/parts/categories" element={<PartsCategoriesAll />} />
                        <Route path=":lang/parts/categories/:part" element={<PartsListingAll />} />

                        <Route path=":lang/used-part/:part_name/:make/:model/:year/:city/:part_code" element={<PartPage />} />

                        <Route path=":lang/dismantlers" element={<Dismantlers />} />

                        {/*<Route path="mini-site/:companyname/car" element={<DismantlerCars />} />*/}
                        {/*<Route path="mini-site/:companyname/parts" element={<DismantlerParts />} />*/}
                        {/*<Route path="mini-site/:companyname/company" element={<DismantlerCompany />} />*/}
                        {/*<Route path="mini-site/:companyname/gallery" element={<DismantlerGallery />} />*/}

                        <Route path=":lang/mini-site" element={<DismantlerLayout />} >
                            <Route path="cars/:merchantid/:companyname" element={<DismantlerCars />} />
                            <Route path="parts/:merchantid/:companyname" element={<DismantlerParts />} />
                            <Route path="parts/:merchantid/:companyname/:part" element={<DismantlerPartsCategory />} />
                            <Route path="company/:merchantid/:companyname" element={<DismantlerCompany />} />
                            <Route path="gallery/:merchantid/:companyname" element={<DismantlerGallery />} />
                        </Route>


                        <Route path=":lang/cars/listing" element={<CarsListing />} />
                        <Route path=":lang/cars/search" element={<CarsSearch />} />

                        <Route path=":lang/used-car/:make/:model/:year/:city/:ad_code" element={<CarPage />} />


                        <Route element={<ProtectedRoute />}>
                            <Route path=":lang/part-request" element={<PartRequest />} />
                        </Route>

                        <Route path=":lang/terms" element={<Terms />} />
                        <Route path=":lang/about-us" element={<AboutUs />} />
                        <Route path=":lang/how-it-works" element={<HowItWorks />} />
                        <Route path=":lang/faq" element={<Faq />} />
                        <Route path=":lang/privacy-policy" element={<PrivacyPolicy />} />
                        <Route path=":lang/cookie-policy" element={<CookiePolicy />} />
                        <Route path=":lang/support" element={<Support />} />
                        <Route path=":lang/contact" element={<Contact />} />
                        <Route path=":lang/ads-policy" element={<AdsPolicy />} />
                        <Route path=":lang/imprint" element={<Imprint />} />
                    </Route>
                </Routes>
            </AuthProvider>
        </BrowserRouter>
        </HelmetProvider>
    );
}

export default App;
